// extracted by mini-css-extract-plugin
export var isBlock = "button-module--isBlock--29126";
export var isChip = "button-module--isChip--22988";
export var isLoading = "button-module--isLoading--a86b8";
export var isPrimary = "button-module--isPrimary--6c40d";
export var isSecondary = "button-module--isSecondary--162aa";
export var isText = "button-module--isText--1ae74";
export var main = "button-module--main--e3c02";
export var noUnderline = "button-module--noUnderline--0d43f";
export var rotation = "button-module--rotation--6d233";